import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/atoms/button';

export default function ActivationSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md text-center">
        {/* Logo */}
        <Link to="/" className="flex items-end justify-center gap-2 mb-8">
          <img src="/volovolo.png" alt="Volovolo" className="h-10 w-auto" />
          <span className="font-bold text-xl">Pro</span>
        </Link>

        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold mb-2">
          {t('activation.successTitle')}
        </h1>

        {/* Description */}
        <p className="text-muted-foreground mb-6">
          {t('activation.successDescription')}
        </p>

        {/* Countdown */}
        <p className="text-sm text-muted-foreground mb-6">
          {t('activation.redirecting', { seconds: countdown })}
        </p>

        {/* Button */}
        <Button asChild className="w-full">
          <Link to="/login">{t('activation.goToLogin')}</Link>
        </Button>
      </div>
    </div>
  );
}
